import * as React from 'react';
import { SelectedBaggageService } from './types';

interface ContextProps {
	onBaggageIconClick?: () => void;
	onBaggageDelete?: (servicesToDelete: SelectedBaggageService[]) => void;
	isReadOnly?: boolean;
}

export const BaggageContext = React.createContext<ContextProps>(null);

const BaggageContextProvider = BaggageContext.Provider;
export default BaggageContextProvider;
